// Update these with real values when ready
export const SITE = {
  name: "Surer Adda With Sanchayeeta",
  url: "https://sureraddawithsanchayeeta.in",
  tagline: "Bengali Versatile & Live Performance Singer · Voiceover · Music Albums",
  facebookUrl: "https://www.facebook.com/sureraddawithsanchayeeta",
  upi: {
    id: "8670871548-2@ybl",
    payeeName: "SANCHAYEETA SEAL",
  },
  contact: {
    email: "info@sureraddawithsanchayeeta.in",
    phone: "+91-9733002082",
    whatsapp: "919733002082",
  },
};
